/**
 * Uploads API URL helpers
 *
 * Centralizes the base uploads URL and project naming used for fetching client data.
 * This module is intentionally lightweight and has no dependency on other services
 * to avoid circular imports.
 */

// Base URL for the uploads API (can be overridden via environment variable)
export const UPLOADS_BASE_URL = process.env.REACT_APP_UPLOADS_API_URL || 'https://uploads.traffixcloud.com';

// Project name used in the uploads API path
export const PROJECT_NAME = 'traffix_all_in_one';

/**
 * Build a full URL for a client data file on the remote API (without auth)
 * @param {string} clientType - The client identifier (e.g., 'lavagna', 'default')
 * @param {string} filePath - Relative path to the file (e.g., 'signal_fix/Car_gps.geojson')
 * @returns {string} Full API URL
 */
export const getClientFileUrl = (clientType, filePath) => {
  const cleanPath = filePath.startsWith('/') ? filePath.slice(1) : filePath;
  return `${UPLOADS_BASE_URL}/api/browse/${PROJECT_NAME}/${clientType}/${cleanPath}`;
};
